module.exports = __webpack_public_path__ + "static/media/Piercing-ear-lobe.e851f99b.png";